export const SET_PRODUCT_BRANDS = 'PRODUCTS_BRANDS/SET_PRODUCT_BRANDS';
export const SET_PRODUCT_BRANDS_IS_LOADING = 'PRODUCTS_BRANDS/SET_PRODUCT_BRANDS_IS_LOADING';
export const SET_SINGLE_PRODUCT_BRAND_IS_LOADING = 'PRODUCTS_BRANDS/SET_SINGLE_PRODUCT_BRAND_IS_LOADING';
export const SET_SINGLE_PRODUCT_BRAND = 'PRODUCTS_BRANDS/SET_SINGLE_PRODUCT_BRAND';
export const CLEAR_SINGLE_PRODUCT_BRAND = 'PRODUCTS_BRANDS/CLEAR_SINGLE_PRODUCT_BRAND';